import React, { useEffect, useState } from 'react';
import { Form, Button, Input, Select, Modal, Icon } from '@whalecloud/fdx';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import { i18n } from 'fishx';
import { useSelector } from 'react-redux';
import { DEALER_EVENT_CODE, SERVICE_TYPE } from '@/utils';
import config from './config';
import styles from './index.module.less';

const { Option } = Select;
const { confirm } = Modal;
const { formItemLayout, searchTypeOptionList } = config;
function SearchBox(props) {
  const {
    dispatch,
    certTypeList,
    customerList,
    form: { getFieldDecorator, validateFields, getFieldValue, setFieldsValue },
    dealerEventCode,
    modelKey,
    serviceTypeList,
  } = props;

  const [multiCustomer, setMultiCustomer] = useState(false); // 标识点击query后查出多个客户的情况
  const orgInfo = useSelector(({ dxpGlobal }) => dxpGlobal.currentUser.orgInfo || {});
  // 根据eventCode判断是哪些页面
  const isNewConnectionPage = dealerEventCode === DEALER_EVENT_CODE.NEW_CONNECTION;
  const isModifyForService = dealerEventCode === DEALER_EVENT_CODE.MODIFY_FOR_SERVICE;

  const getModuleI18n = path => i18n(`SEARCH_${path}`);

  const modifyTypeList = [{
    label: getModuleI18n('BILLING_RELATED_INFO'),
    value: 'modifyAccount',
  }, {
    label: getModuleI18n('ACCOUNT_RELATED_INFO'),
    value: 'modifyCustomer',
  }];

  useEffect(() => {
    // 查询证件类型列表
    dispatch({ type: 'search/qryCertType' });
    // 查询服务类型
    if (isNewConnectionPage) {
      dispatch({
        type: 'search/qryServiceTypeByFr',
        payload: {
          params: {
            dealerEventCode,
            orgId: orgInfo.orgId,
          },
        },
      });
    } else {
      dispatch({
        type: 'search/qryServiceType',
        payload: {
          params: {
            dealerEventCode,
          },
        },
      });
    }
  }, []);

  const handleQuery = e => {
    e.preventDefault();
    validateFields(async (err, values) => {
      if (!err) {
        const { searchType, documentType, customerSearch, serviceType, modidyType } = values;
        const defaultParams = {};
        const moreParmas = {};
        if (searchType === searchTypeOptionList[0].value) {
          // 用户名
          defaultParams.custCode = customerSearch;
        } else if (searchType === searchTypeOptionList[2].value) {
          // 证件类型
          defaultParams[searchType] = customerSearch;
          moreParmas.certTypeId = documentType;
        } else {
          defaultParams[searchType] = customerSearch;
        }
        const params = {
          ...defaultParams,
          ...moreParmas,
        };
        // 点击query精确查询
        const custInfoList = await dispatch({
          type: 'search/qryCustList',
          payload: {
            params,
          },
        });
        // 获取用户信息失败以及是新开页面
        if (isEmpty(custInfoList) && isNewConnectionPage) {
          showNotExsitInfo();
        }
        // 成功后同步各个模块数据
        if (!isEmpty(custInfoList)) {
          // 储存服务类型
          if (serviceType) {
            await dispatch({
              type: `${modelKey}/save`,
              payload: {
                serviceType: serviceTypeList.find(item => item.serviceType === serviceType),
              },
            });
          }
          if (modidyType) {
            await dispatch({
              type: `${modelKey}/save`,
              payload: {
                modidyType,
              },
            });
          }
          // 如果查到不止一条客户数据，弹出选择框，选中后跳转
          if (custInfoList.length > 1) {
            setMultiCustomer(true);
          } else {
            onCustomerSelect(custInfoList[0]);
          }
        }
      }
    });
  };

  const onCustomerSelect = value => {
    dispatch({
      type: `${modelKey}/save`,
      payload: {
        searchCustInfo: value,
      },
    });
  }

  const showNotExsitInfo = () => {
    confirm({
      title: getModuleI18n('NO_EXSIT_TITLE'),
      content: getModuleI18n('NO_EXSIT_CONTENT'),
      maskClosable: true,
      icon: <Icon type="info-circle" />,
      okText: getModuleI18n('CONTINUE'),
      onCancel() {},
      onOk() {
        const serviceType = getFieldValue('serviceType');
        dispatch({
          type: `${modelKey}/save`,
          payload: {
            isCreate: true,
            serviceType: serviceTypeList.find(item => item.serviceType === serviceType),
          },
        });
      },
    });
  };

  const handleNew = () => {
    validateFields(['serviceType'], (err, value) => {
      if (!err) {
        dispatch({
          type: `${modelKey}/save`,
          payload: {
            isCreate: true,
            serviceType: serviceTypeList.find(item => item.serviceType === value.serviceType),
          },
        });
      }
    });
  };

  const onCustSearch = value => {
    if (value) {
      const defaultParams = {};
      defaultParams[getFieldValue('searchType')] = value;
      const params = {
        ...defaultParams,
      };
      if (value.length >= 4) {
        dispatch({
          type: 'search/qryCustList',
          payload: {
            params,
          },
        });
      } else {
        // 小于4个字符，情况列表
        dispatch({
          type: 'search/save',
          payload: {
            customerList: [],
          },
        });
      }
    }
  };

  const debunceCustSearch = debounce(onCustSearch, 500);

  const handleSearchTypeChange = value => {
    if (getFieldValue('searchType') !== value) {
      setFieldsValue({ customerSearch: '' });
    }
  };

  const handleDocumentType = value => {
    if (getFieldValue('documentType') !== value) {
      setFieldsValue({ customerSearch: '' });
    }
  };

  const renderModifyTypeSelect = () => (
    <Form.Item
      label={getModuleI18n('MODIFY_TYPE')}
    >
      {getFieldDecorator('modidyType', {
        rules: [{ required: true, message: getModuleI18n('PLS_SERVICE_TYPE') }],
      })(
        <Select
          placeholder={i18n('COMMON_PLEASE_SELECT')}
        >
          {
            modifyTypeList.map(item =>
              <Option key={item.value} value={item.value}>{item.label}</Option>
            )
          }
        </Select>
      )}
    </Form.Item>
  );

  const renderCustomerSearchInput = () => (
    <Form.Item
      label={getModuleI18n('CUSTOMER_SEARCH')}
    >
      {getFieldDecorator('customerSearch', {
        rules: [
          { required: true, message: getModuleI18n('PLS_SEARCH_CONTENT') },
        ],
      })(
        <Select
          showSearch
          defaultActiveFirstOption
          placeholder={i18n('COMMON_PLEASE_INPUT')}
          showArrow={false}
          filterOption={false}
          onSearch={debunceCustSearch}
        >
          {customerList.map(item => (
            <Option
              key={item.custCode}
              value={item.custCode}
            >
              <div style={{ display: 'none' }}>{item.custName}</div>
              <div style={getFieldValue('customerSearch') === item.custCode ? { color: '#4477EE' } : { color: '#575966' }}>{`${getModuleI18n('CUSTOMER_NAME')}: ${item.custName}`}</div>
              <div style={getFieldValue('customerSearch') === item.custCode ? { color: '#95b2f5' } : { color: '#abacb2' }}>{`${getModuleI18n('DOCUMENT_TYPE')}: ${item.certTypeName}`}</div>
              <div style={getFieldValue('customerSearch') === item.custCode ? { color: '#95b2f5' } : { color: '#abacb2' }}>{`${getModuleI18n('DOCUMENT_NUMBER')}: ${item.certNbr}`}</div>
            </Option>
          ))}
        </Select>
      )}
    </Form.Item>
  );

  const renderCustomerInput = () => (
    <Form.Item
      label={getModuleI18n('CUSTOMER_SEARCH')}
    >
      {getFieldDecorator('customerSearch', {
        rules: [
          { required: true, message: getModuleI18n('PLS_SEARCH_CONTENT') },
          { min: 4, message: getModuleI18n('LAST_CHARACTERS') },
        ],
      })(
        // 如果查出多个客户信息，弹出选择框；重新输入变为输入框
        multiCustomer ? (
          <Select
            allowClear={true}
            showSearch
            defaultActiveFirstOption
            placeholder={i18n('COMMON_PLEASE_INPUT')}
            showArrow={false}
            filterOption={false}
            onSelect={value => { onCustomerSelect(customerList.find(cust => cust.custCode === value)) }}
            defaultOpen={true}
            onSearch={() => { setMultiCustomer(false); }}
          >
            {customerList.map(item => (
              <Option
                key={item.custCode}
                value={item.custCode}
              >
                <div style={{ display: 'none' }}>{item.custName}</div>
                <div style={{ color: '#575966' }}>{`${getModuleI18n('CUSTOMER_NAME')}: ${item.custName}`}</div>
                <div style={{ color: '#abacb2' }}>{`${getModuleI18n('DOCUMENT_TYPE')}: ${item.certTypeName}`}</div>
                <div style={{ color: '#abacb2' }}>{`${getModuleI18n('DOCUMENT_NUMBER')}: ${item.certNbr}`}</div>
              </Option>
            ))}
          </Select>) : (
            <Input
              placeholder={i18n('COMMON_PLEASE_INPUT')}
              autoComplete="off"
            />
        )
      )}
    </Form.Item>
  );

  const renderServiceSelect = () => (
    <Form.Item
      label={getModuleI18n('SERVICE_TYPE')}
    >
      {getFieldDecorator('serviceType', {
        rules: [{ required: true, message: getModuleI18n('PLS_SERVICE_TYPE') }],
      })(
        <Select
          placeholder={i18n('COMMON_PLEASE_SELECT')}
        >
          {
            serviceTypeList.map(item =>
              <Option key={item.serviceType} value={item.serviceType}>{item.serviceTypeName}</Option>
            )
          }
        </Select>
      )}
    </Form.Item>
  );

  return (
    <div className={styles.searchBoxWarp}>
      <div className={styles.searchBoxContainer}>
        <h3 className={styles.searchBoxContainerTitle}>{i18n(isNewConnectionPage ? 'SEARCH_TITLE_NEW' : 'SEARCH_TITLE')}</h3>
        <div className={styles.searchBox}>
          <Form onSubmit={handleQuery} {...formItemLayout}>
            {
              isModifyForService && renderModifyTypeSelect()
            }
            {
              isNewConnectionPage ?
                renderServiceSelect() :
                null
            }
            <Form.Item
              label={getModuleI18n('TYPE')}
            >
              {getFieldDecorator('searchType', {
                rules: [{ required: true, message: getModuleI18n('PLS_SEARCH_TYPE') }],
                // 2883724 Search Type默认值为Mobile Number
                initialValue: 'contactMobilePhone',
              })(
                <Select
                  placeholder={i18n('COMMON_PLEASE_SELECT')}
                  onChange={handleSearchTypeChange}
                >
                  {
                    searchTypeOptionList.map(item =>
                      <Option key={item.value} value={item.value}>{i18n(item.labelKey)}</Option>
                    )
                  }
                </Select>
              )}
            </Form.Item>
            {
              // 选择证件联动
              getFieldValue('searchType') === searchTypeOptionList[2].value &&
                (
                  <Form.Item
                    label={getModuleI18n('DOCUMENT_TYPE')}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 12 }}
                  >
                    {getFieldDecorator('documentType', {
                      rules: [{ required: true, message: getModuleI18n('PLS_DOCUMENT_TYPE') }],
                    })(
                      <Select
                        placeholder={i18n('COMMON_PLEASE_SELECT')}
                        onChange={handleDocumentType}
                      >
                        {
                          certTypeList.map(item =>
                            <Option key={item.certTypeId} value={item.certTypeId}>{item.certTypeName}</Option>
                          )
                        }
                      </Select>
                    )}
                  </Form.Item>
                )}
            {
                getFieldValue('searchType') === searchTypeOptionList[0].value ?
                  renderCustomerSearchInput() :
                  renderCustomerInput()
              }
            <div className={styles.searchBoxFooter}>
              {
                // 选择线索类型，没有查询按钮
                (getFieldValue('serviceType') === SERVICE_TYPE.NODE_LEASED_NETWORK ||
                getFieldValue('serviceType') === SERVICE_TYPE.LEASED_PORT) ||
                <Button
                  type="primary"
                  htmlType="submit"
                >
                  {i18n('BTN_QUERY')}
                </Button>
              }
              {
                isNewConnectionPage &&
                  <Button
                    type="primary"
                    onClick={handleNew}
                  >
                    {i18n('COMMON_NEW')}
                  </Button>
              }
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Form.create({ name: 'search-box' })(SearchBox);
